import axios from 'axios';

export default function submitFormHubSpot(formId, submitData, {
  setSubmitting,
  onSuccess,
  onError,
}) {
  const formUrl = `https://api.hsforms.com/submissions/v3/integration/submit/${formId}`;

  axios.post(formUrl, submitData)
    .then(() => {
      setSubmitting(false);
      onSuccess();
    })
    .catch((error) => {
      setSubmitting(false);
      onError(error);
    });
}
